// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

import apiHandle from '../../../../configs/apiConfig'


export const overdueCreate = createAsyncThunk('overdue/application/create', async (params) => {
  const response = await apiHandle('POST', 'application/paybalance', params)
  return response
})

export const overdueRefund = createAsyncThunk('overdue/application/refund', async (params) => {
  const response = await apiHandle('POST', 'application/refund', params)
  return response
})

export const overdueDelete = createAsyncThunk('overdue/application/delete', async (params) => {
  const response = await apiHandle('POST', 'application/delete', params)
  return response
})


export const overduePDFCreate = createAsyncThunk('overdue/application/pdf/create', async (params) => {
  const response = await apiHandle('POST', 'application/pdf', params)
  return response
})

export const overdueReaderCard = createAsyncThunk('overdue/overdueReaderCard', async () => {
  const response = await apiHandle('GET', 'mockreadercard')
  return response
})

export const getDataTable = createAsyncThunk('overdue/getDataTable', async (params) => {
  const response = await apiHandle('GET', 'application/gettable', params)
  return response
})

export const overdueDataDetail = createAsyncThunk('overdue/overdueDataDetail', async (params) => {
  const response = await apiHandle('GET', 'application/get', params)
  return response
})

export const overdueGetCourse = createAsyncThunk('overdue/overdueGetCourse', async (params) => {
  const response = await apiHandle('GET', 'application/getforoverdue', params)
  return response
})

export const getAllData = createAsyncThunk('overdue/getAllData', async () => {
  const response = await axios.get('/api/users/list/all-data')
  return response.data
})

export const getData = createAsyncThunk('overdue/getData', async params => {
  const response = await axios.get('/api/users/list/data', params)
  return {
    params,
    data: response.data.users,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('overdue/getUser', async id => {
  const response = await axios.get('/api/users/user', { id })
  return response.data.user
})

export const addUser = createAsyncThunk('overdue/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('overdue/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

const defaultCoruseCost = {
  course_id: '',
  course_name: null,
  promotion_code: null,
  exam_date: null,
  cost: null,
  discount: null,
  paid: null,
  pay_type: null
}

const defaultOtherCost = {
  other_fee_id: null,
  other_fee_name: null,
  promotion_code: null,
  exam_date: null,
  cost: null,
  discount: null,
  paid: null,
  pay_type: null
}

const defaultPayments = {
  payment_id: null,
  payment_code: null,
  pay_type: null,
  paid: null,
  createdAt: null
}


const defaultReisterDetail = {
  is_foreigner: false,
  prefix: '',
  name: '',
  idcard: '',
  birthday: null,
  address: null,
  moo: '',
  soi: '',
  street: '',
  subdistrict: '',
  district: '',
  province: '',
  phone_1: '',
  phone_2: '',
  age: '',
  course: [defaultCoruseCost],
  other_fee: [defaultOtherCost],
  payments: [defaultPayments],
  paid: '',
  discount: '',
  net: '',
  balance: '',
  total: '',
  // pay_type: 'เงินสด',
  status: null,
  application_code: null,
  course_id: '',
  createStatus: false,
  application_id: null,
  pdf: []
}


export const overdueSlice = createSlice({
  name: 'overdue',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    searchCriteria: {
      branch: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      status: { label: 'ค้างชำระ', value: 'ค้างชำระ' },
      type: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      text: ''
    },
    overdueData: {
      data: [],
      filter: {
        branch: [],
        status: [],
        type: []
      },
      meta: {},
      isLoading: false
    },
    overdueDetail: {
      isEdit: false,
      dropdown: {
        course: [],
        other_fee: []
      },
      userData: defaultReisterDetail
    },
    alert: {
      active: false,
      message: ''
    },
    refundAndDelete: {
      application_id: null,
      note: null,
      value: null,
      err: false
    }
  },
  reducers: {
    searchCriteria: (state, action) => {
      if (action.type === 'overdue/searchCriteria') {
        state.searchCriteria[action.payload.target] = action.payload.value
      }
    },
    overdueNew: (state, action) => {
      if (action.type === 'overdue/overdueNew') {
        state.overdueDetail.isEdit = false
        state.overdueDetail.userData = defaultReisterDetail
      }
    },
    overdueAddHandle: (state, action) => {
      if (action.type === 'overdue/overdueAddHandle') {
        if (action.payload.target === 'course') {
          state.overdueDetail.userData.course.push(defaultCoruseCost)
        }
        if (action.payload.target === 'other') {
          state.overdueDetail.userData.other_fee.push(defaultOtherCost)
        }

      }
    },
    overdueDeleteHandle: (state, action) => {
      if (action.type === 'overdue/overdueDeleteHandle') {
        if (action.payload.target === 'course') {
          state.overdueDetail.userData.course.splice(action.payload.index, 1)
        }
        if (action.payload.target === 'other') {
          state.overdueDetail.userData.other_fee.splice(action.payload.index, 1)
        }

      }

    },
    overdueDropdownHandle: (state, action) => {
      if (action.type === 'overdue/overdueDropdownHandle') {
        console.log(action.payload.target)
        if (action.payload.target === 'course' && state.overdueDetail.isEdit === false) {
          state.overdueDetail.userData.course[action.payload.index].course_id = action.payload.value.course_id
          state.overdueDetail.userData.course[action.payload.index].course_name = action.payload.value.name
          state.overdueDetail.userData.course[action.payload.index].cost = action.payload.value.price
        }
        if (action.payload.target === 'examDate') {
          state.overdueDetail.userData.course[action.payload.index].exam_date = action.payload.value
        }
        if (action.payload.target === 'other' && state.overdueDetail.isEdit === false) {
          state.overdueDetail.userData.other_fee[action.payload.index].other_fee_id = action.payload.value.other_fee_id
          state.overdueDetail.userData.other_fee[action.payload.index].other_fee_name = action.payload.value.name
          state.overdueDetail.userData.other_fee[action.payload.index].cost = action.payload.value.price
        }
        if (action.payload.target === 'pay_type') {
          state.overdueDetail.userData[action.payload.mode][action.payload.index].pay_type = action.payload.value
        }
      }
    },
    overdueOnChangeHandle: (state, action) => {
      if (action.type === 'overdue/overdueOnChangeHandle') {
        if (action.payload.target === 'paid') {
          state.overdueDetail.userData[action.payload.mode][action.payload.index][action.payload.target] = action.payload.value
        } else {
          state.overdueDetail.userData[action.payload.target] = action.payload.value
        }

      }
    },
    overdueLoading: (state, action) => {
      if (action.type === 'overdue/overdueLoading') {
        state.overdueData.isLoading = true
      }
    },
    overdueAlert: (state, action) => {
      if (action.type === 'overdue/overdueAlert') {
        state.alert.active = false
        state.alert.message = ''
        state.alert.err = false
      }
    },
    overdueRefundDelete: (state, action) => {
      if (action.type === 'overdue/overdueRefundDelete') {
        if (action.payload.target === null) {
          state.refundAndDelete.application_id = null
          state.refundAndDelete.note = null
          state.refundAndDelete.value = null
        } else {
          state.refundAndDelete[action.payload.target] = action.payload.value
        }

      }
    }

  },
  extraReducers: builder => {
    builder
      .addCase(overdueCreate.fulfilled, (state, action) => {
        if (action.type === 'overdue/application/create/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            console.log(action)
            state.alert.active = true
            state.alert.message = action.payload.data.pdf
            // state.overdueDetail.userData.createStatus = true
            // state.overdueDetail.userData.pdf = action.payload.data
          }
        }
      })
      .addCase(overdueRefund.fulfilled, (state, action) => {
        if (action.type === 'overdue/application/refund/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
            state.refundAndDelete.application_id = null
            state.refundAndDelete.note = null
            state.refundAndDelete.value = null
            state.alert.active = true
            state.alert.err = true
            state.alert.message = action.payload.message
          } else {
            state.refundAndDelete.application_id = null
            state.refundAndDelete.note = null
            state.refundAndDelete.value = null
            state.alert.active = true
            state.alert.message = action.payload.message
          }
        }
      })
      .addCase(overdueDelete.fulfilled, (state, action) => {
        if (action.type === 'overdue/application/delete/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.refundAndDelete.application_id = null
            state.refundAndDelete.note = null
            state.refundAndDelete.value = null
            state.alert.active = true
            state.alert.message = action.payload.message
          }
        }
      })
      .addCase(getDataTable.fulfilled, (state, action) => {
        if (action.type === 'overdue/getDataTable/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.overdueData = action.payload
            state.overdueData.isLoading = false
          }
        }
      })
      .addCase(overdueDataDetail.fulfilled, (state, action) => {
        if (action.type === 'overdue/overdueDataDetail/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            console.log(action)
            state.overdueDetail.isEdit = true
            state.overdueDetail.userData.prefix = action.payload.data.customer.prefix ? action.payload.data.customer.prefix : ''
            state.overdueDetail.userData.name = action.payload.data.customer.name ? action.payload.data.customer.name : ''
            state.overdueDetail.userData.idcard = action.payload.data.customer.idcard ? action.payload.data.customer.idcard : ''
            state.overdueDetail.userData.birthday = action.payload.data.customer.birthday ? action.payload.data.customer.birthday : null
            state.overdueDetail.userData.address = action.payload.data.customer.address ? action.payload.data.customer.address : ''
            state.overdueDetail.userData.moo = action.payload.data.customer.moo ? action.payload.data.customer.moo : ''
            state.overdueDetail.userData.soi = action.payload.data.customer.soi ? action.payload.data.customer.soi : ''
            state.overdueDetail.userData.street = action.payload.data.customer.street ? action.payload.data.customer.street : ''
            state.overdueDetail.userData.province = action.payload.data.customer.province ? action.payload.data.customer.province : ''
            state.overdueDetail.userData.district = action.payload.data.customer.district ? action.payload.data.customer.district : ''
            state.overdueDetail.userData.subdistrict = action.payload.data.customer.subdistrict ? action.payload.data.customer.subdistrict : ''
            state.overdueDetail.userData.phone_1 = action.payload.data.customer.phone_1 ? action.payload.data.customer.phone_1 : ''
            state.overdueDetail.userData.phone_2 = action.payload.data.customer.phone_2 ? action.payload.data.customer.phone_2 : ''
            state.overdueDetail.userData.status = action.payload.data.status ? action.payload.data.status : null
            state.overdueDetail.userData.application_code = action.payload.data.application_code ? action.payload.data.application_code : null
            state.overdueDetail.userData.paid = action.payload.data.paid === 0 ? '0' : action.payload.data.paid
            state.overdueDetail.userData.course_id = action.payload.data.paid ? action.payload.data.course_id.toString() : ''
            state.overdueDetail.userData.discount = action.payload.data.discount === 0 ? '0' : action.payload.data.discount.toString()
            state.overdueDetail.userData.net = action.payload.data.net === 0 ? '0' : action.payload.data.net.toString()
            state.overdueDetail.userData.balance = action.payload.data.balance === 0 ? '0' : action.payload.data.balance.toString()
            state.overdueDetail.userData.total = action.payload.data.total === 0 ? '0' : action.payload.data.total.toString()
            state.overdueDetail.userData.payments = action.payload.data.payments
            state.overdueDetail.userData.application_id = action.payload.data.application_id
            state.overdueDetail.userData.is_foreigner = action.payload.data.customer.is_foreigner
            state.overdueDetail.userData.course = [
              {
                course_id: action.payload.data.course_id ? action.payload.data.course_id.toString() : '',
                course_name: null,
                promotion_code: null,
                exam_date: null,
                cost: action.payload.data.balance ? action.payload.data.balance.toString() : '',
                discount: null,
                paid: null,
                pay_type: null
              }
            ]
          }
        }
      })
      .addCase(overdueGetCourse.fulfilled, (state, action) => {
        if (action.type === 'overdue/overdueGetCourse/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.overdueDetail.dropdown.course = action.payload.course
            state.overdueDetail.dropdown.other_fee = action.payload.other_fee
          }
        }
      })
      .addCase(overdueReaderCard.fulfilled, (state, action) => {
        if (action.type === 'overdue/overdueReaderCard/fulfilled') {
          if (action.payload.result === 'ok') {
            state.overdueDetail.userData.prefix = action.payload.title_th
            state.overdueDetail.userData.name = `${action.payload.fname_th} ${action.payload.sname_th}`
            state.overdueDetail.userData.idcard = action.payload.nat_id
            state.overdueDetail.userData.birthday = action.payload.birthdate
            state.overdueDetail.userData.address = action.payload.address_no
            state.overdueDetail.userData.street = action.payload.address_road
            state.overdueDetail.userData.province = action.payload.address_provinice
            state.overdueDetail.userData.district = action.payload.address_amphor
            state.overdueDetail.userData.subdistrict = action.payload.address_tumbol
            state.overdueDetail.userData.age = null

          } else {
            //handleError
          }
        }
      })
      .addCase(overduePDFCreate.fulfilled, (state, action) => {
        if (action.type === 'overdue/application/pdf/create/fulfilled') {
          if (action.payload.status === 'success') {
            window.open(action.payload.data.pdf, '_blank')
          } else {
            //handleError
          }
        }
      })
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })

  }
})

export const { searchCriteria, overdueNew, overdueAddHandle, overdueDropdownHandle, overdueDeleteHandle, overdueOnChangeHandle, overdueLoading, overdueAlert, overdueRefundDelete } = overdueSlice.actions

export default overdueSlice.reducer
